import React, { Component } from "react"

import Screen from '../../ui/Screen'

import TitlePanel from "./EditTemplateScreen/TitlePanel.js"
import ControlPanel from "./EditTemplateScreen/ControlPanel.js"
import AttachmentsList from "./EditTemplateScreen/AttachmentsList.js"
import ActionPanel from "./EditTemplateScreen/ActionPanel.js"

import SelectItemDialog from "../../inventory/SelectItemDialog.js"
import EditAttachmentDialog from "./EditTemplateScreen/EditAttachmentDialog.js"
import RemoveAttachmentDialog from "./EditTemplateScreen/RemoveAttachmentDialog.js"


/**
 * template
 * 
 * onSaveClick(template)
 * onCancelClick
 * 
 * Компонент создаёт копию объекта template в которую вносятся все изменения вложений.
 * Для новых вложений id будет установлен как "new{n}", где n - локальный индекс. 
 * Для того, что бы определить является ли вложение новым нужно выполнить проверку isNaN(Number(attachment.id))
 */

class EditTemplateScreen extends Component {

    constructor(props) {
        super(props)

        this.state = {
            dialog: undefined,
            selected: undefined,
            template: global.structuredClone(this.props.template),
            id_counter: 0,
        }

        this.handle_onEditClick = this.handle_onEditClick.bind(this)
    }

    handle_onEditClick(attachment) {
        this.setState({
            dialog: <EditAttachmentDialog 
                attachment = {attachment}
                onSaveClick = {attachment => {
                    let a = this.state.template.attachments.find(a => a.id === attachment.id)
                    a.quantity = attachment.quantity
                    a.shop_id = attachment.shop_id
                    a.shop = attachment.shop
                    this.setState({dialog: undefined})
                }}
                onCancelClick = {() => {this.setState({dialog: undefined})}}
            />
        })
    }

    render() {
        return <Screen
            onClick = {e => {
                e.stopPropagation()
                if (!this.state.dialog) {this.setState({selected: undefined})}
            }}
        >

            {this.state.dialog}

            <TitlePanel title = {`Шаблон: ${this.state.template.name}`} />

            <ControlPanel 
                selected = {this.state.selected}
                onAttachClick = {() => {
                    this.setState({
                        dialog: <SelectItemDialog
                            onSelectItem = {item => {
                                let attachment = {
                                    id: "new" + this.state.id_counter,
                                    item_id: item.id,
                                    item: item,
                                    shop_id: item.shops.length ? item.shops[0].id : undefined,
                                    shop: item.shops.length ? item.shops[0] : undefined,
                                    template_id: this.state.template.id,
                                    quantity: 1,
                                }
                                this.setState({
                                    id_counter: this.state.id_counter + 1,
                                    dialog: <EditAttachmentDialog 
                                        attachment = {attachment}
                                        onSaveClick = {attachment => {
                                            this.state.template.attachments.push(attachment)
                                            this.setState({
                                                dialog: undefined,
                                                selected: attachment,
                                            })
                                        }}
                                        onCancelClick = {() => {this.setState({dialog: undefined})}}
                                    />
                                })
                            }}
                            onCancel = {() => {this.setState({dialog: undefined})}}
                        />
                    })
                }}
                onEditClick = {this.handle_onEditClick}
                onRemoveClick = {attachment => {
                    this.setState({
                        dialog: <RemoveAttachmentDialog 
                            attachment = {this.state.selected}
                            onRemoveClick = {attachment => {
                                this.state.template.attachments = this.state.template.attachments.filter(a => a.id !== attachment.id )
                                this.setState({selected: undefined, dialog: undefined})
                            }}
                            onCancelClick = {() => {this.setState({dialog: undefined})}}
                        />
                    })
                }}
            />

            <AttachmentsList
                attachments = {this.state.template.attachments}
                selected = {this.state.selected}
                onClickAttachment = {attachment => {this.setState({selected: attachment})}}
                onDoubleClickAttachment = {this.handle_onEditClick}
            />

            <ActionPanel 
                onSaveClick = {() => {
                    if (typeof this.props.onSaveClick === "function") {
                        this.props.onSaveClick(this.state.template)
                    }
                }}
                onCancelClick = {() => {
                    if (typeof this.props.onCancelClick === "function") {
                        this.props.onCancelClick()
                    }
                }}
            />

        </Screen>
    }

}

export default EditTemplateScreen